import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '../../../app.config.vars/routes';
const RallyDoesNotExist = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    return (_jsxs("div", { className: 'modal-content rally-does-not-exist', children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { title: t('admin.rally_does_not_exist'), type: 'h1' }) }), _jsx("div", { className: "modal-content-button", children: _jsx(Button, { label: t('button.ok'), onClick: async () => {
                        navigate(APP_ROUTES.rallies);
                        dispatch(setIsModalOpen(false));
                        dispatch(setModalContent(null));
                    } }) })] }));
};
export default RallyDoesNotExist;
